export enum Branding {
  BES = 1,
  Vulcan = 2
}